export const getPointDifferentialPercentage = (pointsEarned, pointsAgainst) => {
    if (pointsEarned <= 0 || pointsAgainst <= 0) {
        return '0%';
    }
    const decimal = parseFloat(((pointsEarned - pointsAgainst) / (pointsEarned + pointsAgainst)) * 100);
    return `${decimal.toFixed(2)}%`;
};

export default getPointDifferentialPercentage;
